import React from 'react';

const Videos = () => {
    // Array of video IDs from the YouTube embeds you provided
    const videoIds = [
        "xBu_CL-8rqo", // Corrected YouTube video ID
        "O0cCa0_ANug"  // Corrected YouTube video ID
    ];

    return (
        <section id="videos" className="videos-section">
            <div className="videos-container">
                <h2 className="videos-title">Nos Vidéos</h2>
                <div className="video-grid">
                    {videoIds.map((id, index) => (
                        <div key={index} className="video-responsive">
                            <iframe
                                src={`https://www.youtube.com/embed/${id}`} // Uses the correct YouTube embed URL format
                                title={`YouTube video player ${index + 1}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
                .videos-section {
                    padding: 60px 20px;
                    background-color: #f0f4f8; /* Light gray background, similar to contact */
                    text-align: center;
                }

                .videos-container {
                    max-width: 1200px;
                    margin: 0 auto;
                }

                .videos-title {
                    font-size: 2.5rem;
                    margin-bottom: 40px;
                    color: #1A365D; /* Dark blue title */
                    text-transform: uppercase;
                    font-weight: bold;
                }

                .video-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Responsive grid */
                    gap: 30px; /* Space between videos */
                    justify-content: center;
                }

                .video-responsive {
                    position: relative;
                    padding-bottom: 56.25%; /* 16:9 aspect ratio (height / width = 9 / 16 = 0.5625) */
                    height: 0;
                    overflow: hidden;
                    max-width: 100%;
                    background: #000; /* Background while loading or if video not found */
                    border-radius: 10px;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
                }

                .video-responsive iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: 0;
                }

                /* Media Queries */
                @media (max-width: 768px) {
                    .videos-title {
                        font-size: 2.2rem;
                        margin-bottom: 30px;
                    }
                    .video-grid {
                        gap: 20px;
                    }
                }

                @media (max-width: 480px) {
                    .videos-title {
                        font-size: 1.9rem;
                    }
                    .videos-section {
                        padding: 40px 15px;
                    }
                }
            `}</style>
        </section>
    );
};

export default Videos;
